import { render, staticRenderFns } from "./PhoneMockup.vue?vue&type=template&id=50fac514&scoped=true"
import script from "./PhoneMockup.vue?vue&type=script&lang=js"
export * from "./PhoneMockup.vue?vue&type=script&lang=js"
import style0 from "./PhoneMockup.vue?vue&type=style&index=0&id=50fac514&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50fac514",
  null
  
)

export default component.exports